// Brand configuration — all values come from environment variables.
// Set these in your Render dashboard (or .env file locally) per deployment.
// Defaults are set to Polaris so existing deployments keep working with no changes.

const brand = {
  name: process.env.REACT_APP_BUSINESS_NAME || 'Polaris Pro Mobile Detailing',
  nameShort: process.env.REACT_APP_BUSINESS_NAME_SHORT || 'Polaris',
  tagline: process.env.REACT_APP_BUSINESS_TAGLINE || 'Professional Mobile Detailing',
  primaryColor: process.env.REACT_APP_PRIMARY_COLOR || '#C9A227',
  logoUrl: process.env.REACT_APP_LOGO_URL || '/assets/polaris-logo.png',
};

export default brand;
